/**
 * web-vitals-tracking.js
 * Envoie les Core Web Vitals des vrais visiteurs dans le dataLayer (événements web_vitals_*),
 * avec l'élément en cause (debug_target) et la phase / le script responsable (debug_cause),
 * pour savoir quoi corriger. Dépend de web-vitals.attribution.js (chargé juste avant).
 */
(function () {
  'use strict';
  var vitals = window.webVitals;
  if (!vitals) return;

  // Limite GA4 de longueur d'une valeur de paramètre.
  var MAX_PARAM_LENGTH = 100;
  var RATING_RANK = { good: 0, 'needs-improvement': 1, poor: 2 };
  var sentRatings = {};

  function clip(text, keepEnd) {
    if (!text) return '';
    if (text.length <= MAX_PARAM_LENGTH) return text;
    return keepEnd ? text.slice(-MAX_PARAM_LENGTH) : text.slice(0, MAX_PARAM_LENGTH);
  }

  // Nom de fichier pour nos scripts et ceux de Shopify, hôte + fichier pour un tiers.
  function scriptName(url) {
    if (!url) return 'inline';
    try {
      var parsed = new URL(url, location.href);
      // Un script écrit dans la page a l'URL de la page comme source.
      if (parsed.origin + parsed.pathname === location.origin + location.pathname) return 'inline';
      var file = parsed.pathname.split('/').pop() || parsed.hostname;
      var host = parsed.hostname;
      var isOwn = host === location.hostname || host === 'cdn.shopify.com' || /\.myshopify\.com$/.test(host);
      return isOwn ? file : host + '/' + file;
    } catch (e) {
      return 'unknown';
    }
  }

  function dominantPhase(phases) {
    var best = '';
    var bestValue = -1;
    Object.keys(phases).forEach(function (name) {
      if (phases[name] > bestValue) {
        best = name;
        bestValue = phases[name];
      }
    });
    return best;
  }

  function inpCause(a) {
    var phase = dominantPhase({
      input_delay: a.inputDelay,
      processing: a.processingDuration,
      presentation: a.presentationDelay,
    });
    var script = a.longestScript && a.longestScript.entry;
    if (!script) return phase;
    var fn = script.sourceFunctionName ? '#' + script.sourceFunctionName : '';
    return phase + ':' + scriptName(script.sourceURL) + fn;
  }

  function lcpCause(a) {
    var phase = dominantPhase({
      ttfb: a.timeToFirstByte,
      load_delay: a.resourceLoadDelay,
      load_duration: a.resourceLoadDuration,
      render_delay: a.elementRenderDelay,
    });
    return a.url ? phase + ':' + scriptName(a.url) : phase;
  }

  function ttfbCause(a) {
    return dominantPhase({
      waiting: a.waitingDuration,
      cache: a.cacheDuration,
      dns: a.dnsDuration,
      connection: a.connectionDuration,
      request: a.requestDuration,
    });
  }

  function fcpCause(a) {
    return dominantPhase({ ttfb: a.timeToFirstByte, render: a.firstByteToFCP });
  }

  function describe(metric) {
    var a = metric.attribution || {};
    switch (metric.name) {
      case 'INP':
        return { target: a.interactionTarget, cause: inpCause(a) };
      case 'LCP':
        return { target: a.target, cause: lcpCause(a) };
      case 'CLS':
        return { target: a.largestShiftTarget, cause: a.loadState };
      case 'TTFB':
        return { target: '', cause: ttfbCause(a) };
      default:
        return { target: '', cause: fcpCause(a) };
    }
  }

  // Un envoi par page (metric.id, renouvelé après un retour bfcache). INP et CLS sont rappelés à chaque
  // mise en arrière-plan : si la note se dégrade, on renvoie « ancienne>nouvelle » pour reclasser la page.
  function send(metric) {
    var previous = sentRatings[metric.id];
    if (previous && RATING_RANK[metric.rating] <= RATING_RANK[previous]) return;
    sentRatings[metric.id] = metric.rating;

    var detail = describe(metric);
    var value = metric.name === 'CLS' ? Math.round(metric.value * 10000) / 10000 : Math.round(metric.value);
    var data = {
      metric_value: value,
      metric_rating: previous ? previous + '>' + metric.rating : metric.rating,
      debug_target: clip(detail.target, true),
      debug_cause: clip(detail.cause, false),
    };
    var eventName = 'web_vitals_' + metric.name.toLowerCase();

    if (typeof window.trackEvent === 'function') {
      window.trackEvent(eventName, data);
    } else {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: eventName }, data));
    }
  }

  vitals.onLCP(send);
  vitals.onINP(send);
  vitals.onCLS(send);
  vitals.onFCP(send);
  vitals.onTTFB(send);
})();
